import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QueueComponent } from './queue.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SharedModule } from '@shared/shared.module';
import { QueueActionButtonsComponent } from '@shared/component/queue-action-buttons/queue-action-buttons.component';

@NgModule({
  declarations: [QueueComponent],
  imports: [
    CommonModule,
    SharedModule,
    QueueActionButtonsComponent,
  ],
  exports: [QueueComponent],
  providers: [
    ConfirmationService, MessageService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QueueModule {
}
